import React from 'react';
import { Link } from 'react-router-dom';

import localStorage from '../../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';
import { StaticRoutePaths } from '../../Common/ClientRoutes';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

const UserDetails = props => {
    return (
        <div>
            <div className="row">
                <div className="col-12 color-dark-gray">{strings.Role}</div>
                <div className="col-12 color-light-blue mb-1 qf-big-text">{props.role}</div>
            </div>
            <div className="row">
                <div className="col-12 color-dark-gray">{strings.Name}</div>
                <div className="col-12 color-light-blue mb-1 qf-big-text">{props.name}</div>
            </div>
            <div className="row">
                <div className="col-12 color-dark-gray">{strings.Email}</div>
                <div className="col-12 color-light-blue mb-1 qf-big-text">{props.email}</div>
            </div>
            <div className="row">
                <div className="col-12 color-dark-gray">{strings.phone}</div>
                <div className="col-12 color-light-blue mb-4 qf-big-text">{props.phone}</div>
            </div>
            <div className="row">
                <div className="col-2 qf-mb-30">
                    <Link className="qf-blue-btn w-100" to={StaticRoutePaths.INFO_DETAILS_USER}>
                        {strings.Edit_User}
                    </Link>
                </div>
                <div className="col-2 qf-mb-30">
                    <Link className="qf-blue-btn w-100" to={StaticRoutePaths.INFO_PASSWORD_USER}>
                        {strings.Edit_Password}
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default UserDetails;



// WEBPACK FOOTER //
// ./src/customModules/Users/components/User-details.js